<div class="rounded-[8px] border border-[#919EAB80] px-[16px] py-[8px] bg-white flex gap-[8px]"
  [class]="containerClass">
  <fa-icon [icon]="faMagnifyingGlass" class="text-[#637381] self-center" />
  <input [ngModel]="searchText" (ngModelChange)="onChange($event)"
    class="flex-1 min-w-0 focus:outline-none focus:ring-0 focus:border-transparent placeholder-[#637381] text-[14px] bg-transparent"
    type="text" [placeholder]="placeholder" />
</div>